module.exports = __webpack_public_path__ + "static/c4-39da13a771c99658aa72b429999736d3.jpeg";